import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const getLinkStyle = (path) => ({
    color: '#2c3e50',
    textDecoration: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    transition: 'background-color 0.3s',
    fontWeight: location.pathname === path ? 'bold' : 'normal'
  });

  return (
    <nav style={{
      backgroundColor: 'white',
      padding: '1rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000
    }}>
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '6px',
        background: 'linear-gradient(to right, #A80C2F, #FFA600)'
      }}></div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/" style={{
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          fontSize: '1.5rem',
          fontWeight: '700',
          color: '#2c3e50'
        }}>
          The AI Outpost
        </Link>
      </div>
      
      {/* Desktop Navigation */}
      {!isMobile && (
        <div style={{ display: 'flex', gap: '2rem' }}>
          <Link to="/" style={getLinkStyle('/')}>
            Home
          </Link>
          <a 
            href="https://rorossssss.app.n8n.cloud/form/f995fefc-885b-4af9-9336-60402602d894" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: '#2c3e50',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              transition: 'background-color 0.3s',
              fontWeight: 'normal'
            }}
          >
            Events
          </a>
          <Link to="/tutorials" style={getLinkStyle('/tutorials')}>
            Tutorials
          </Link>
          <Link to="/prompt-library" style={getLinkStyle('/prompt-library')}>
            Prompt Library
          </Link>
          <Link to="/admin" style={getLinkStyle('/admin')}>
            Admin
          </Link>
        </div>
      )}

      {/* Mobile Hamburger Menu */}
      {isMobile && (
        <>
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              zIndex: 1001
            }}
          >
            <div style={{ width: '24px', height: '3px', backgroundColor: '#2c3e50', borderRadius: '2px', transition: 'all 0.3s', transform: isOpen ? 'rotate(45deg) translateY(7px)' : 'none' }}></div>
            <div style={{ width: '24px', height: '3px', backgroundColor: '#2c3e50', borderRadius: '2px', transition: 'all 0.3s', opacity: isOpen ? '0' : '1' }}></div>
            <div style={{ width: '24px', height: '3px', backgroundColor: '#2c3e50', borderRadius: '2px', transition: 'all 0.3s', transform: isOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }}></div>
          </button>

          {/* Mobile Menu Dropdown */}
          {isOpen && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              display: 'flex',
              flexDirection: 'column',
              zIndex: 999
            }}>
              <Link 
                to="/" 
                style={{
                  ...getLinkStyle('/'),
                  padding: '1rem 2rem',
                  borderBottom: '1px solid #eee'
                }}
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <a 
                href="https://rorossssss.app.n8n.cloud/form/f995fefc-885b-4af9-9336-60402602d894" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  color: '#2c3e50',
                  textDecoration: 'none',
                  padding: '1rem 2rem',
                  borderRadius: '0',
                  transition: 'background-color 0.3s',
                  fontWeight: 'normal',
                  borderBottom: '1px solid #eee'
                }}
                onClick={() => setIsOpen(false)}
              >
                Events
              </a>
              <Link 
                to="/tutorials" 
                style={{
                  ...getLinkStyle('/tutorials'),
                  padding: '1rem 2rem',
                  borderBottom: '1px solid #eee'
                }}
                onClick={() => setIsOpen(false)}
              >
                Tutorials
              </Link>
              <Link 
                to="/prompt-library" 
                style={{
                  ...getLinkStyle('/prompt-library'),
                  padding: '1rem 2rem',
                  borderBottom: '1px solid #eee'
                }}
                onClick={() => setIsOpen(false)}
              >
                Prompt Library
              </Link>
              <Link 
                to="/admin" 
                style={{
                  ...getLinkStyle('/admin'),
                  padding: '1rem 2rem'
                }}
                onClick={() => setIsOpen(false)}
              >
                Admin
              </Link>
            </div>
          )}
        </>
      )}
    </nav>
  );
};

export default Navbar;
